import { useState } from 'react'

import Badge from '@zet/common/components/badge'
import { B2, BottomSheet, Pressable, Stack, colors } from '@zet/design-system'
import { Chip } from '@zet/design-system/chip'
import { TeamEarningsFilterTabProps } from '@zet/my-teams/src/api/teamEarnings/types'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'
import { NativeViewGestureHandler } from 'react-native-gesture-handler'

import { EarningsFiltersList } from '../earningsFiltersList'

const EarningsFilterTab = ({
  filters,
  filterLabel,
  filterIcon,
  filterName,
  type,
  setFilters,
}: TeamEarningsFilterTabProps) => {
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false)
  const onPressFilterChip = () => {
    setIsBottomSheetVisible(!isBottomSheetVisible)
  }
  const currentFilter = filters?.filters?.find(
    (item) => item?.name === filterName
  )
  const onDismiss = () => {
    setIsBottomSheetVisible(false)
  }

  return (
    <Pressable onPress={onPressFilterChip}>
      <Chip
        primaryIconType={filterIcon}
        className="border-1 border-grays-40 ml-2 self-start bg-white px-2"
        secondaryIconType="ArrowDown"
        primaryIconColor={colors.neutral.black100}
        type="outlined"
        secondaryIconColor={colors.neutral.black100}
      >
        <B2 className="text-grays-80">{filterLabel}</B2>
      </Chip>
      {currentFilter?.value?.length > 0 ? (
        <Badge count={currentFilter.value.length} />
      ) : (
        <></>
      )}
      <BottomSheet
        visible={isBottomSheetVisible}
        onDismiss={onDismiss}
        disableBottomSheet={onDismiss}
        bodyStyle={{ maxHeight: DEVICE_HEIGHT * 0.9 }}
      >
        <NativeViewGestureHandler disallowInterruption={true}>
          <Stack>
            <EarningsFiltersList
              type={type}
              filterName={filterName}
              filterLabel={filterLabel}
              filterIcon={filterIcon}
              selectedFilters={filters}
              setSelectedFilters={setFilters}
              setIsBottomSheetVisible={onPressFilterChip}
            />
          </Stack>
        </NativeViewGestureHandler>
      </BottomSheet>
    </Pressable>
  )
}

export default EarningsFilterTab
